import * as React from "react";
import type { AppPaddleButtonProps } from "./AppPaddleButton.types";

export const useOnExecute: (props: AppPaddleButtonProps) => () => void = (
  props
) => {
  const { id, onExecute } = props;

  return React.useCallback(() => {
    if (onExecute) {
      onExecute(id);
    }
  }, [id, onExecute]);
};
